import { orange, white } from '@/theme/colors'
import { fontDisplay } from '@/theme/fonts'
import { radii } from '@/theme/tokens'
import styled from 'styled-components'

export const TagPillEl = styled.span`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 11px;
	background: ${orange};
	color: ${white};
	padding: 3px 9px;
	border-radius: ${radii.pill};
	width: fit-content;
	white-space: nowrap;
`
